import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './styles.module.scss';
import { ReportReferenceContainer as ReportReference } from './report-reference.container';
import { getReferenceReports } from '../chat-message-utils';
export var ChatMessageView = function (_a) {
    var message = _a.message;
    return (_jsxs("div", { className: classNames(styles.chatMessage, styles[message.role]), children: [_jsx(Markdown, { remarkPlugins: [remarkGfm], children: message.content.text }), getReferenceReports(message).map(function (reportId) { return (_jsx(ReportReference, { reportId: reportId }, reportId)); })] }));
};
